import type { MouseEvent } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { DropdownMenuItem } from "~/components/ui/dropdown-menu";
import { Text } from "~/components/text";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

export interface BulkGenerateOptionProps {
  label: string;
  disabled?: boolean;
  tooltip?: string;
  loading?: boolean;

  onClick: (event: MouseEvent) => void;
}

export function BulkGenerateOption({
  disabled,
  tooltip,
  loading,
  onClick,
  label,
}: BulkGenerateOptionProps) {
  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        {/* A disabled menu item ignores pointer events, so the span receives the hover. */}
        <span>
          <DropdownMenuItem
            className="py-2.5 px-3 cursor-pointer"
            disabled={disabled}
            onClick={onClick}
          >
            {loading ? (
              <Loader2 className="w-5 h-5 mr-2 animate-spin" />
            ) : (
              <Sparkles className="w-5 h-5 mr-2" />
            )}
            <Text as="span">{label}</Text>
          </DropdownMenuItem>
        </span>
      </TooltipTrigger>
      {tooltip ? (
        <TooltipContent
          side="bottom"
          className="font-light text-center shadow-tooltip text-secondary-600 whitespace-pre px-5 z-10 border-none"
          sideOffset={3}
        >
          <TooltipArrow
            className="fill-white drop-shadow-xs"
            width={12}
            height={6}
          />
          {tooltip}
        </TooltipContent>
      ) : null}
    </Tooltip>
  );
}
